<template>
  <div class="login-container">
    <div class="login-form-wrapper">
      <div class="login-logo">
        <h2>游戏库管理系统</h2>
      </div>
      <el-form 
        ref="loginForm" 
        :model="loginForm" 
        :rules="loginRules" 
        class="login-form"
      >
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            style="width: 100%" 
            size="large"
            @click="handleLogin"
            :loading="loading"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api/gameApi.js'
export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            // 调用真实的登录API
            const response = await authApi.login({
              username: this.loginForm.username,
              password: this.loginForm.password
            })
            
            if (response.code === 200 && response.data) {
              // 登录成功，保存token和用户信息到localStorage
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('username', response.data.username)
              
              this.$message.success('登录成功')
              // 登录成功后跳转到游戏管理页面
              this.$router.push('/')
            } else {
              // 登录失败
              this.$message.error(response.msg || '登录失败，请检查用户名和密码')
            }
          } catch (error) {
            this.$message.error('登录失败，请稍后再试')
            console.error('Login error:', error)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  background-image: 
    radial-gradient(circle at 25px 25px, rgba(147, 197, 253, 0.1) 2%, transparent 0%),
    radial-gradient(circle at 75px 75px, rgba(147, 197, 253, 0.1) 2%, transparent 0%);
  background-size: 100px 100px;
}

.login-form-wrapper {
  width: 400px;
  background-color: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.login-logo {
  text-align: center;
  margin-bottom: 30px;
}

.login-logo h2 {
  color: #1890ff;
  margin: 0;
  font-size: 24px;
}

.login-form {
  width: 100%;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

/* 自定义输入框样式 */
.login-form .el-input__inner {
  border-radius: 4px;
}

/* 自定义按钮样式 */
.login-form .el-button--primary {
  border-radius: 4px;
  background-color: #1890ff;
  border-color: #1890ff;
}

.login-form .el-button--primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
}
</style>